// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"drag-move","clipPath":"url(#clip0_543_5327)"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 5L12 2L9 5M8.99999 19L12 22L15 19M19 15L22 12L19 9M5 8.99999L2 12L5 15M12 3V12M12 12V21M12 12H21M12 12H3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DragMoveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'drag-move',
    ref,
    icon: element,
  },
));

DragMoveIcon.displayName = 'DragMoveIcon';

export default DragMoveIcon;
